module.exports = __webpack_public_path__ + "img/5af4a7c.jpg";